import barba from '@barba/core';

export default class LanguageSwitcher {
	static init(el) {
		const LanguageSwitcherElms = el.detail.element.querySelectorAll('[data-language-switcher]');
		LanguageSwitcherElms.forEach((elm) => {
			new LanguageSwitcher(elm);
		});
	}

	constructor(elm) {
		if (!elm) {
			return;
		}

		this.elm = elm;
		this.elm.addEventListener('change', (e) => {
			const options = this.elm.options;
			if (!options) {
				return;
			}
			const url = this.elm.options[this.elm.options.selectedIndex].value;
			if (!url) {
				return;
			}
			barba.go(url);
		});
	}
}
